// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0bdb19aa","389":"bb0cab42","453":"3c155fb4","455":"69886ff5","977":"a6078446"}[chunkId] + ".chunk.js";
};